import { render, staticRenderFns } from "./SalesHistory.template.vue?vue&type=template&id=33a11799&scoped=true&"
var script = {}
import style0 from "./SalesHistory.template.vue?vue&type=style&index=0&id=33a11799&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a11799",
  null
  
)

export default component.exports